import React from 'react';
import style from '../Stylesheets/Home.module.css';

function Home() {
  return (
      <div className={style.headtop}>
        <h1 className={style.h1}>The Codebreakers Club</h1>
        <p className={style.p}>Breaking codes, Creating minds!!</p>
      </div>
  );
}

export default Home
